import { openModal } from "action/modal/openModal";
import PAImage from "component/design-system/images/PAImage";
import { useTranslation } from "next-i18next";
import { useDispatch } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./utility-grid.module.scss";

const valueProps = [
  {
    title: "Lowest Prices in Canada*",
    subtitle: "Check deals",
    img: "/images/home/lower-price-pa.webp",
    fallbackImg: "/images/home/lower-price-pa.jpg",
    url: "/",
    alt: "Unbeatable Canadian Prices on Automotive Parts",
    modalId: "lowPriceModal",
  },
  {
    title: "Free 1-3 day delivery over $99*",
    subtitle: "Read more",
    img: "/images/home/shipping-pa.webp",
    fallbackImg: "/images/home/shipping-pa.jpg",
    url: "/auto-parts-free-shipping-canada",
    alt: "FREE 1-3 day delivery over $99* on all auto parts orders",
    modalId: "freeDeliveryModal",
  },
  {
    title: "2 million auto parts in stock",
    subtitle: "Check now",
    img: "/images/home/catelog-pa.webp",
    fallbackImg: "/images/home/catelog-pa.jpg",
    url: "/replacement-parts",
    alt: "Canada's Widest Range of Automotive Parts and Accessories",
    modalId: "browseCatalogModal",
  },
  {
    title: "Local Pickup & Delivery",
    subtitle: "Read more",
    img: "/images/home/instorepickup-pa.webp",
    fallbackImg: "/images/home/instorepickup-pa.jpg",
    url: "/in-store-pickup",
    alt: "Complimentary In-Store Auto Parts Pickup Service",
    modalId: "fastDeliveryModal",
  },
];

function UtilityGrid() {
  const { t } = useTranslation("home");
  const dispatch = useDispatch();

  function gridClickHandler(modalId: string) {
    dispatch(openModal(modalId));
  }

  return (
    <div className={`${styles.utility_grid}`}>
      {valueProps.map((item, idx) => (
        <div className={`${styles.each_grid}`} key={idx} onClick={() => gridClickHandler(item.modalId)}>
          <div className={`${styles.grid_container}`}>
            <div className={`${styles.icon_container}`}>
              <PAImage
                src={getRelativeImagePath(item.img)}
                fallBackImage={getRelativeImagePath(item.fallbackImg)}
                width={39}
                height={39}
                unoptimized
                className={`${styles.img} ${styles.desktopIcon}`}
                alt={item.alt}
                title={item.alt}
              />
              <i className={`fa fa-check ${styles.mobileIcon}`} />
            </div>
            <div className={`${styles.status_container}`}>
              <div className={`${styles.tile_title}`}>{t(item.title)}</div>
              {/* <div className={`${styles.tile_link}`}>{item.subtitle}</div> */}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
export default UtilityGrid;
